export default function (money: number): string {
  money = money / 100;
  const formatter = new Intl.NumberFormat('en-US',
    { style: 'currency', currency: 'USD', }
  );
  return formatter.format(money);
}
